// Reusable framer-motion variants. Keep animations consistent across pages
// by composing these instead of writing one-off transitions inline.
//
// Convention:
//  - Use `fadeUp` for top-level page sections.
//  - Use `staggerContainer` + `staggerItem` for grids/lists that should
//    cascade in.
//  - Use `whileInView` with `viewportOnce` for scroll-triggered reveals so
//    each element only animates the first time it enters the viewport.
//  - For interactive cards, use `cardHover` on `whileHover` / `whileTap`.

export const easing = [0.22, 1, 0.36, 1]; // Smooth ease-out (cubic-bezier)

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: easing },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5, ease: easing } },
};

export const slideDown = {
  hidden: { opacity: 0, y: -20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: easing } },
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 18 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: easing },
  },
};

export const scalePop = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.32, ease: easing },
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: { duration: 0.2, ease: easing },
  },
};

export const backdropFade = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};

export const pageTransition = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4, ease: easing } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.25, ease: easing } },
};

export const cardHover = {
  rest: { y: 0, scale: 1 },
  hover: {
    y: -6,
    scale: 1.015,
    transition: { duration: 0.25, ease: easing },
  },
  tap: { scale: 0.985, transition: { duration: 0.15 } },
};

export const viewportOnce = { once: true, amount: 0.2 };
